import { render } from "./tokenLogin.vue?vue&type=template&id=3ed9670b"
import script from "./tokenLogin.vue?vue&type=script&lang=js"
export * from "./tokenLogin.vue?vue&type=script&lang=js"

import exportComponent from "D:\\phpstudy_pro\\gpt\\chatgpt-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__